import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@material-ui/core/Box";
import {
  Grid,
  Typography,
  makeStyles,
  Card,
  CardContent,
  MenuItem,
  InputLabel,
  Select,
  CardActions,
  Button,
  CardHeader,
  FormControl,
} from "@material-ui/core";

import { useConfirm } from "material-ui-confirm";

import { Link } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-material-ui";

import ShoppingOptions from "../../../components/ShoppingOptions/ShoppingOptions";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const ProductEdit = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const confirm = useConfirm();

  //------ State Ids ----------------
  const [productTypeId, setProductTypeId] = useState(
    props.selectedProduct.ProductTypeId
  );
  const [categoryId, setCategoryId] = useState(
    props.selectedProduct.CategoryId
  );
  const [colorId, setColorId] = useState(props.selectedProduct.ColorId);
  const [metalId, setMetalId] = useState(props.selectedProduct.MetalId);
  const [gemstoneId, setGemstoneId] = useState(
    props.selectedProduct.GemstoneId
  );
  const [pearlTypeId, setPearlTypeId] = useState("");
  const [pearlSizeId, setPearlSizeId] = useState("");
  const [lengthId, setLengthId] = useState("");
  const [productEraId, setProductEraId] = useState("");
  const [discountId, setDiscountId] = useState("");

  //------ State Values ----------------

  const [productName, setProductName] = useState(
    props.selectedProduct.ProductName
  );
  const [shortDescription, setShortDescription] = useState(
    props.selectedProduct.ShortDescription
  );
  const [description, setDescription] = useState(
    props.selectedProduct.Description
  );
  const [size, setSize] = useState(props.selectedProduct.Size);
  const [designer, setDesigner] = useState(props.selectedProduct.Designer);
  const [comments, setProductComments] = useState(
    props.selectedProduct.Comments
  );
  const [slug, setProductSlug] = useState(props.selectedProduct.Slug);
  const [sku, setProductSKU] = useState(props.selectedProduct.SKU);
  const [price, setProductPrice] = useState(props.selectedProduct.Price);
  const [currency, setProductCurrency] = useState(
    props.selectedProduct.Currency
  );
  const [quantity, setProductQuantity] = useState(
    props.selectedProduct.Quantity
  );
  //-----------------------------
  const [newProductId, setNewProductId] = useState("");

  //------ End State ------------

  const initialValues = {
    //required
    productId: props.selectedProduct.ProductId,
    productTypeId: productTypeId,
    categoryId: categoryId,
    //options
    colorId: colorId,
    metalId: metalId,
    gemstoneId: gemstoneId,
    pearlTypeId: pearlTypeId,
    pearlSizeId: pearlSizeId,
    lengthId: lengthId,
    productEraId: productEraId,
    discountId: discountId,
    //product fields
    productName: productName,
    shortDescription: shortDescription,
    description: description,
    designer: designer,
    slug: slug,
    sku: sku,
    price: price,
    currency: currency,
    quantity: quantity,
    size: size,
    comments: comments,
    isActive: true,
  };

  //validation schema
  let validationSchema = Yup.object().shape({
    productId: Yup.number().required("Required"),
    productTypeId: Yup.number().required("Required"),
    categoryId: Yup.number().required("Required"),
    productName: Yup.string().required("Required"),
    shortDescription: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
    slug: Yup.string().required("Required"),
    sku: Yup.string().required("Required"),
    price: Yup.string().required("Required"),
    currency: Yup.string().required("Required"),
    quantity: Yup.string().required("Required"),
    isActive: Yup.bool().required("Required"),
  });

  const onSubmit = async (values) => {
    //console.log(values);
    confirm({
      description: `The changes will be saved to the database.`,
    })
      .then(() => {
        //alert(JSON.stringify(values, null, 2));
        //post the values to api
        fetch(process.env.REACT_APP_API_PRODUCT_EDIT, {
          method: "POST",
          body: JSON.stringify({ ...values }),
          headers: { "Content-Type": "application/json" },
        })
          .then((response) => response.json())
          .then((data) => {
            setNewProductId(data.new_identity);
            handleAddProduct(data.new_identity);
          })
          .catch((err) => {
            console.log(err.message);
          });
        props.setRefreshProducts(true);
      })
      .catch(() => console.log("Action cancelled."));
  };

  const handleAddProduct = (id) => {
    props.setNewProductId(id);
    navigate(`/admin/products/addimages`);
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 8fr",
      }}
    >
      <Grid container justify="center" spacing={4}>
        <Grid item>
          <ShoppingOptions
            productTypes={props.productTypes}
            productTypeId={productTypeId}
            setProductTypeId={setProductTypeId}
            //--------------------------------
            categories={props.categories}
            categoryId={categoryId}
            setCategoryId={setCategoryId}
            //--------------------------------
            productColors={props.productColors}
            colorId={colorId}
            setColorId={setColorId}
            //--------------------------------
            productMetals={props.productMetals}
            metalId={metalId}
            setMetalId={setMetalId}
            //--------------------------------
            productGemstones={props.productGemstones}
            gemstoneId={gemstoneId}
            setGemstoneId={setGemstoneId}
            //--------------------------------
            pearlTypes={props.pearlTypes}
            pearlTypeId={pearlTypeId}
            setPearlTypeId={setPearlTypeId}
            //--------------------------------
            pearlSizes={props.pearlSizes}
            pearlSizeId={pearlSizeId}
            setPearlSizeId={setPearlSizeId}
            //--------------------------------
            productLengths={props.productLengths}
            lengthId={lengthId}
            setLengthId={setLengthId}
            //--------------------------------
            /*             ringSizes={props.ringSizes}
            ringSizeId={ringSizeId}
            setRingSizeId={setRingSizeId} */
            //--------------------------------
            productEras={props.productEras}
            productEraId={productEraId}
            setProductEraId={setProductEraId}
            //--------------------------------
            discounts={props.discounts}
            discountId={discountId}
            setDiscountId={setDiscountId}
            // prevent handleFiltersChange call
            admin={true}
          ></ShoppingOptions>
        </Grid>
      </Grid>

      <Card className={classes.padding}>
        <CardHeader
          title={"Edit: " + props.selectedProduct.ProductName}
        ></CardHeader>
        <Typography variant="h8" display="block">
          Please note that the options should be selected first, before entering
          product specific details. Among the options, Product Type and Category
          are required, any other field is optional.
        </Typography>

        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ dirty, isValid, values, handleChange, handleBlur }) => {
            return (
              <Form>
                <CardContent>
                  <Grid container spacing={4} justify="center">
                    <Grid item xs={3}>
                      <Field
                        label="Product Name"
                        variant="outlined"
                        fullWidth
                        name="productName"
                        value={values.productName}
                        component={TextField}
                        multiline={true}
                      />
                    </Grid>
                    {/*-------------------*/}
                    <Grid item xs={4}>
                      <Field
                        label="Short Description"
                        variant="outlined"
                        fullWidth
                        name="shortDescription"
                        value={values.shortDescription}
                        component={TextField}
                        multiline={true}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <Field
                        label="Description"
                        variant="outlined"
                        fullWidth
                        name="description"
                        value={values.description}
                        component={TextField}
                        multiline={true}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Field
                        label="Size (CT WT)"
                        variant="outlined"
                        fullWidth
                        name="size"
                        value={values.size}
                        component={TextField}
                        multiline={true}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Field
                        label="Designer"
                        variant="outlined"
                        fullWidth
                        name="designer"
                        value={values.designer}
                        component={TextField}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Field
                        label="Comments"
                        variant="outlined"
                        fullWidth
                        name="comments"
                        value={values.comments}
                        component={TextField}
                        multiline={true}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Field
                        label="Slug"
                        variant="outlined"
                        fullWidth
                        name="slug"
                        value={values.slug}
                        component={TextField}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Field
                        label="SKU"
                        variant="outlined"
                        fullWidth
                        name="sku"
                        value={values.sku}
                        component={TextField}
                      />
                    </Grid>

                    {/*-------------------------------*/}
                    <Grid item xs={1}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="select-outlined-label">
                          Is Active
                        </InputLabel>
                        <Select
                          labelId="select-outlined-label"
                          id="select-outlined"
                          label="Is Active"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.isActive}
                          name="isActive"
                        >
                          <MenuItem value="true">
                            <em>true</em>
                          </MenuItem>
                          <MenuItem value="false">
                            <em>false</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  {/* //// */}
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    mt={"2%"}
                  >
                    <Grid
                      container
                      justify="center"
                      spacing={1}
                      className={classes.grid}
                    >
                      <Grid item xs={1}>
                        <Field
                          label="Price"
                          variant="outlined"
                          fullWidth
                          name="price"
                          value={values.price}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <Field
                          label="Currency"
                          variant="outlined"
                          fullWidth
                          name="currency"
                          value={values.currency}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <Field
                          label="Quantity"
                          variant="outlined"
                          fullWidth
                          name="quantity"
                          value={values.quantity}
                          component={TextField}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  {/* /// */}
                  <Grid
                    container
                    justify="center"
                    spacing={1}
                    className={classes.grid}
                  ></Grid>
                  {/* /// */}
                  <CardActions>
                    <Button
                      component={Link}
                      variant="outlined"
                      to="/admin/products/productdetails"
                      /*                       onClick={() => {
                        props.setAction(props.actions.list);
                      }} */
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={!dirty || !isValid}
                      variant="contained"
                      color="primary"
                      type="Submit"
                      className={classes.button}
                    >
                      Save
                    </Button>
                  </CardActions>
                </CardContent>
              </Form>
            );
          }}
        </Formik>
      </Card>
    </div>
  );
};

export default ProductEdit;
